import { render, staticRenderFns } from "./PopupPlatform.vue?vue&type=template&id=2c1605d1&scoped=true&"
import script from "./PopupPlatform.vue?vue&type=script&lang=js&"
export * from "./PopupPlatform.vue?vue&type=script&lang=js&"
import style0 from "./PopupPlatform.vue?vue&type=style&index=0&id=2c1605d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1605d1",
  null
  
)

export default component.exports